import MyClaimOverviewPageActionTypes from './my-claim-overview-page-action-types';
import axios from 'axios';

export const loadMyClaimOverviewPage = (claimId) => async(dispatch, getState, { api }) => {
  dispatch({ type: MyClaimOverviewPageActionTypes.LOAD_MY_CLAIM_OVERVIEW_START });
  const state = getState().myGeneralCompetencyClaimOverviewPage;
  try {
    state.cancelToken?.cancel();
    state.cancelToken = axios.CancelToken.source();
    const claim = await api.get(`api/my_general_competency_claims/${claimId}`, {}, state.cancelToken.token);
    let pdfObjectUrl = null;
    if (claim && claim.attachmentFilename) {
      try {
        const blob = await api.get(`api/my_general_competency_claims/${claimId}/attachment`, {}, state.cancelToken.token, 'blob');
        if (blob) {
          pdfObjectUrl = URL.createObjectURL(new File([blob], `claim-${claimId}.pdf`, { type: 'application/pdf' }));
        }
      } catch {
        // attachment may not exist
      }
    }
    dispatch({
      type: MyClaimOverviewPageActionTypes.LOAD_MY_CLAIM_OVERVIEW_END,
      payload: {
        claim: claim ? {
          ...claim,
          occurredAt: claim.occurredAt ? new Date(claim.occurredAt.substring(0, 10) + 'T12:00:00') : null,
          createdOn: claim.createdOn ? new Date(claim.createdOn) : null,
          reviewedAt: claim.reviewedAt ? new Date(claim.reviewedAt) : null
        } : null,
        pdfObjectUrl
      }
    });
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: MyClaimOverviewPageActionTypes.LOAD_MY_CLAIM_OVERVIEW_END });
      throw error;
    }
  }
};

export const cleanupMyClaimOverviewPage = () => (dispatch, getState) => {
  const state = getState().myGeneralCompetencyClaimOverviewPage;
  if (state.pdfObjectUrl) {
    URL.revokeObjectURL(state.pdfObjectUrl);
  }
  dispatch({ type: MyClaimOverviewPageActionTypes.CLEANUP_MY_CLAIM_OVERVIEW });
};

export const openOverviewDeleteDialog = () => (dispatch) => {
  dispatch({ type: MyClaimOverviewPageActionTypes.TOGGLE_DELETE_CLAIM_DIALOG });
};

export const closeOverviewDeleteDialog = () => (dispatch) => {
  dispatch({ type: MyClaimOverviewPageActionTypes.TOGGLE_DELETE_CLAIM_DIALOG });
};

export const confirmOverviewDelete = () => async(dispatch, getState, { api, history }) => {
  const state = getState().myGeneralCompetencyClaimOverviewPage;
  const claimId = state.claim?.id;
  if (claimId) {
    try {
      await api.remove(`api/my_general_competency_claims/${claimId}`);
      history.back();
    } catch (error) {
      dispatch({ type: MyClaimOverviewPageActionTypes.TOGGLE_DELETE_CLAIM_DIALOG });
    }
  }
};
